import { render, staticRenderFns } from "./UpdateClientUser.vue?vue&type=template&id=5c975676&"
import script from "./UpdateClientUser.vue?vue&type=script&lang=js&"
export * from "./UpdateClientUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports